import { MoreMenuIcon } from "@taunggyi-plus/design-system";
import { LinkWordmark } from "@taunggyi-plus/design-system";
import { useEffect, useState } from "react";

import { BrandLogo, Card, GlobeIcon } from "@taunggyi-plus/design-system";
import type { Locale } from "@taunggyi-plus/domain";
import { CustomerAuthDialog } from "@taunggyi-plus/hotel-feature";

const localeLabels: Record<Locale, string> = {
  en: "English",
  my: "မြန်မာ",
  shn: "တႆး",
  zh: "中文",
};

const content = {
  en: {
    account: "Account",
    signIn: "Sign in or create account",
    signInHelp: "Manage bookings, orders, requests, and saved activity.",
    general: "General",
    about: "About TaungGyi Link",
    aboutHelp: "Our service area, purpose, and organization.",
    language: "Language",
    legal: "Legal, safety & support",
    terms: "Terms & Conditions",
    termsHelp: "Rules for using TaungGyi Link services.",
    privacy: "Privacy Policy",
    privacyHelp: "How we handle account and service information.",
    cancellation: "Cancellation & Refund Policy",
    cancellationHelp: "Guidance for cash bookings, orders, and requests.",
    safety: "Safety & Community Guidelines",
    safetyHelp: "Respectful and responsible platform use.",
    support: "Contact & Support",
    supportHelp: "Get help with your TaungGyi Link experience.",
    version: "App version",
    close: "Close information",
    owner: "Owned and operated by 13/ Taung Gyi Organization.",
    aboutBody:
      "TaungGyi Link is a local multi-service platform for Taunggyi Town. Customers and visitors from anywhere in the world are welcome to explore the app and request services that are delivered or fulfilled within Taunggyi.",
    termsBody:
      "Use accurate account and contact information. Bookings, orders, calls, and delivery requests remain subject to partner availability and confirmation. Cash payments are made directly to the relevant partner. Fraud, abuse, unlawful activity, and misuse of another person’s information are prohibited.",
    privacyBody:
      "We use account, contact, booking, order, and delivery information only to operate and protect the requested service. Access is limited by role, and we do not sell personal information. You may contact support to request access, correction, or deletion where applicable.",
    cancellationBody:
      "The initial release uses cash payment and does not collect online payments. Cancellation eligibility depends on the service status and partner preparation. Any cash refund is handled by the partner that received the payment.",
    safetyBody:
      "Treat customers, partners, drivers, and riders respectfully. Confirm provider details before handing over cash or goods. TaungGyi Link is not an emergency service; contact the appropriate local authority when urgent help is required.",
    supportBody:
      "Support channels and operating hours will be published here before the public launch. Keep your booking or order reference ready when requesting assistance.",
  },
  my: {
    account: "အကောင့်",
    signIn: "အကောင့်ဝင်ရန် သို့မဟုတ် ဖန်တီးရန်",
    signInHelp: "ဘွတ်ကင်၊ မှာယူမှုနှင့် တောင်းဆိုမှုများကို စီမံပါ။",
    general: "အထွေထွေ",
    about: "TaungGyi Link အကြောင်း",
    aboutHelp: "ဝန်ဆောင်မှုဧရိယာ၊ ရည်ရွယ်ချက်နှင့် အဖွဲ့အစည်း။",
    language: "ဘာသာစကား",
    legal: "ဥပဒေ၊ လုံခြုံရေးနှင့် အကူအညီ",
    terms: "စည်းမျဉ်းနှင့် သတ်မှတ်ချက်များ",
    termsHelp: "TaungGyi Link အသုံးပြုမှုဆိုင်ရာ စည်းမျဉ်းများ။",
    privacy: "ကိုယ်ရေးအချက်အလက် မူဝါဒ",
    privacyHelp: "အကောင့်နှင့် ဝန်ဆောင်မှုအချက်အလက် ကိုင်တွယ်ပုံ။",
    cancellation: "ပယ်ဖျက်ခြင်းနှင့် ငွေပြန်အမ်း မူဝါဒ",
    cancellationHelp: "ငွေသားဘွတ်ကင်နှင့် မှာယူမှုများအတွက် လမ်းညွှန်။",
    safety: "လုံခြုံရေးနှင့် အသိုင်းအဝိုင်း လမ်းညွှန်",
    safetyHelp: "လေးစားမှုရှိပြီး တာဝန်ယူသော အသုံးပြုမှု။",
    support: "ဆက်သွယ်ရန်နှင့် အကူအညီ",
    supportHelp: "TaungGyi Link အသုံးပြုရာတွင် အကူအညီရယူပါ။",
    version: "အက်ပ်ဗားရှင်း",
    close: "အချက်အလက်ပိတ်မည်",
    owner: "13/ Taung Gyi Organization မှ ပိုင်ဆိုင်ပြီး စီမံသည်။",
    aboutBody:
      "TaungGyi Link သည် တောင်ကြီးမြို့အတွက် ဒေသခံဝန်ဆောင်မှုပလက်ဖောင်းဖြစ်သည်။ ကမ္ဘာတစ်ဝန်းရှိ ဖောက်သည်နှင့် ဧည့်သည်များက အက်ပ်ကို ကြည့်ရှုနိုင်ပြီး တောင်ကြီးမြို့အတွင်း ဆောင်ရွက်မည့် ဝန်ဆောင်မှုများကို တောင်းဆိုနိုင်သည်။",
    termsBody:
      "မှန်ကန်သော အကောင့်နှင့် ဆက်သွယ်ရန်အချက်အလက်ကို အသုံးပြုပါ။ ဘွတ်ကင်၊ မှာယူမှုနှင့် တောင်းဆိုမှုများသည် ပါတနာ၏ ရရှိနိုင်မှုနှင့် အတည်ပြုမှုအပေါ် မူတည်သည်။ လိမ်လည်မှုနှင့် မသင့်လျော်သော အသုံးပြုမှုကို တားမြစ်သည်။",
    privacyBody:
      "တောင်းဆိုထားသော ဝန်ဆောင်မှုကို ဆောင်ရွက်ရန်နှင့် ကာကွယ်ရန်သာ အကောင့်၊ ဆက်သွယ်ရန်၊ ဘွတ်ကင်နှင့် မှာယူမှုအချက်အလက်ကို အသုံးပြုသည်။ ကိုယ်ရေးအချက်အလက်ကို ရောင်းချမည်မဟုတ်ပါ။",
    cancellationBody:
      "အစပိုင်းဗားရှင်းတွင် ငွေသားပေးချေမှုသာ အသုံးပြုပြီး အွန်လိုင်းငွေမကောက်ခံပါ။ ပယ်ဖျက်နိုင်မှုသည် ဝန်ဆောင်မှုအခြေအနေနှင့် ပါတနာ၏ ပြင်ဆင်မှုအပေါ် မူတည်သည်။",
    safetyBody:
      "ဖောက်သည်၊ ပါတနာ၊ ယာဉ်မောင်းနှင့် ပို့ဆောင်သူများကို လေးစားပါ။ ငွေ သို့မဟုတ် ပစ္စည်းမပေးမီ ဝန်ဆောင်မှုပေးသူအချက်အလက်ကို အတည်ပြုပါ။ TaungGyi Link သည် အရေးပေါ်ဝန်ဆောင်မှု မဟုတ်ပါ။",
    supportBody:
      "အများပြည်သူစတင်အသုံးပြုမည့်နေ့မတိုင်မီ အကူအညီဆက်သွယ်ရန်နှင့် အလုပ်ချိန်ကို ဤနေရာတွင် ဖော်ပြပါမည်။",
  },
  shn: {
    account: "ဢၵွင်ႉ",
    signIn: "ၶဝ်ႈဢၵွင်ႉ သို့ ႁဵတ်းဢၵွင်ႉမႂ်ႇ",
    signInHelp: "ၸတ်းၵၢၼ်ၵၢၼ်ၸွင်း၊ သင်ႇသိုဝ်ႉလႄႈၶေႃႈယွၼ်း။",
    general: "လွင်ႈတင်းပိုၵ်း",
    about: "လွင်ႈ TaungGyi Link",
    aboutHelp: "ပိုၼ်ႉတီႈဝန်ဆောင်ႈ၊ ယိူင်းဢၢၼ်းလႄႈၸုမ်း။",
    language: "ၽႃႇသႃႇ",
    legal: "မၢႆမီႈ၊ လွင်ႈႁူမ်ႇလူမ်ႈလႄႈၸွႆႈထႅမ်",
    terms: "ၶေႃႈမၵ်းမၼ်ႈ",
    termsHelp: "ပိူင်ၸႂ်ႉ TaungGyi Link။",
    privacy: "မူႇပိူင်လွင်ႈသုၼ်ႇတူဝ်",
    privacyHelp: "ပိူင်ၸတ်းၵၢၼ်ၶေႃႈမုၼ်း။",
    cancellation: "မူႇပိူင်ယႃႉလႄႈသူင်ႇငိုၼ်းၶိုၼ်း",
    cancellationHelp: "ၶေႃႈၼႄတႃႇၵၢၼ်ၸၢႆႇငိုၼ်းၼႂ်းမိုဝ်း။",
    safety: "လွင်ႈႁူမ်ႇလူမ်ႈလႄႈပိူင်တူင်ႇဝူင်း",
    safetyHelp: "ၸႂ်ႉတိုဝ်းၸွမ်းပုၼ်ႈၽွၼ်း။",
    support: "ၵပ်းသိုပ်ႇလႄႈၸွႆႈထႅမ်",
    supportHelp: "ႁပ်ႉလွင်ႈၸွႆႈထႅမ်။",
    version: "ဝႃးသျိၼ်း app",
    close: "ပိၵ်ႉၶေႃႈမုၼ်း",
    owner: "13/ Taung Gyi Organization ပဵၼ်ၸဝ်ႈၶွင်လႄႈၸတ်းၵၢၼ်။",
    aboutBody:
      "TaungGyi Link ပဵၼ် platform ဝန်ဆောင်ႈတႃႇဝဵင်းတူၼ်ႈတီး။ ၵူၼ်းၸႂ်ႉလႄႈၶႅၵ်ႇတီႈၵူႈတီႈၼႂ်းလုမ်ႈၾႃႉတူၺ်း app လႄႈယွၼ်းဝန်ဆောင်ႈဢၼ်ႁဵတ်းၼႂ်းတူၼ်ႈတီးလႆႈ။",
    termsBody:
      "ၸႂ်ႉၶေႃႈမုၼ်းဢၵွင်ႉလႄႈၵပ်းသိုပ်ႇဢၼ်မၢၼ်ႇမႅၼ်ႈ။ ၵၢၼ်ၸွင်းလႄႈသင်ႇသိုဝ်ႉၶိုၼ်ႈၵပ်း partner ယိုၼ်ယၼ်။ တႃႇလွင်ႈလႅၼ်လႄႈၸႂ်ႉၽိတ်းၼၼ်ႉ ဢမ်ႇပၼ်ႁဵတ်း။",
    privacyBody:
      "ႁဝ်းၸႂ်ႉၶေႃႈမုၼ်းဢၵွင်ႉ၊ ၵပ်းသိုပ်ႇလႄႈသင်ႇသိုဝ်ႉ တႃႇႁဵတ်းဝန်ဆောင်ႈၵူၺ်း။ ႁဝ်းဢမ်ႇၶၢႆၶေႃႈမုၼ်းသုၼ်ႇတူဝ်။",
    cancellationBody:
      "ဝႃးသျိၼ်းႁႅၵ်ႈၸႂ်ႉငိုၼ်းၼႂ်းမိုဝ်းလႄႈဢမ်ႇႁပ်ႉငိုၼ်း online။ လွင်ႈယႃႉၶိုၼ်ႈၵပ်းငဝ်းလၢႆးဝန်ဆောင်ႈ။",
    safetyBody:
      "ၼပ်ႉယမ်ၵူၼ်းၸႂ်ႉ၊ partner၊ ၽူႈႁေႃႈလႄႈၽူႈသူင်ႇ။ ယိုၼ်ယၼ်ၶေႃႈမုၼ်းမိူဝ်ႈပႆႇပၼ်ငိုၼ်း။ TaungGyi Link ဢမ်ႇၸႂ်ႈဝန်ဆောင်ႈၶိုၵ်ႉၶၵ်ႉ။",
    supportBody: "တေထႅမ်သဵၼ်ႈတၢင်းၵပ်းသိုပ်ႇလႄႈၶၢဝ်းယၢမ်းၸွႆႈထႅမ် ပႆႇပိုတ်ႇၸႂ်ႉတႃႇၵူၼ်းတင်းလၢႆ။",
  },
  zh: {
    account: "账户",
    signIn: "登录或创建账户",
    signInHelp: "管理预订、订单、请求和活动记录。",
    general: "常规",
    about: "关于 TaungGyi Link",
    aboutHelp: "了解服务区域、宗旨和运营组织。",
    language: "语言",
    legal: "法律、安全与支持",
    terms: "条款与条件",
    termsHelp: "使用 TaungGyi Link 服务的规则。",
    privacy: "隐私政策",
    privacyHelp: "我们如何处理账户和服务信息。",
    cancellation: "取消与退款政策",
    cancellationHelp: "现金预订、订单和请求指南。",
    safety: "安全与社区准则",
    safetyHelp: "尊重且负责任地使用平台。",
    support: "联系与支持",
    supportHelp: "获取 TaungGyi Link 使用帮助。",
    version: "应用版本",
    close: "关闭信息",
    owner: "由 13/ Taung Gyi Organization 拥有和运营。",
    aboutBody:
      "TaungGyi Link 是面向东枝市的本地综合服务平台。欢迎世界各地的客户和访客浏览应用，并申请在东枝市内交付或履行的服务。",
    termsBody:
      "请使用准确的账户和联系信息。预订、订单、通话和配送请求取决于合作伙伴的可用性与确认。现金直接支付给相关合作伙伴。禁止欺诈、滥用和违法行为。",
    privacyBody:
      "我们仅为运营和保护所请求的服务而使用账户、联系、预订、订单和配送信息。访问按角色限制，我们不会出售个人信息。",
    cancellationBody:
      "初始版本采用现金支付，不收取在线款项。能否取消取决于服务状态和合作伙伴的准备情况。现金退款由收款合作伙伴处理。",
    safetyBody:
      "请尊重客户、合作伙伴、司机和骑手。交付现金或物品前请确认服务方信息。TaungGyi Link 不是紧急服务；紧急情况请联系当地主管部门。",
    supportBody: "支持渠道和服务时间将在公开发布前公布于此。请求帮助时请准备好预订或订单编号。",
  },
} as const;

export type InformationId = "about" | "terms" | "privacy" | "cancellation" | "safety" | "support";

function requestedInformation(): InformationId | null {
  const value = new URLSearchParams(window.location.search).get("info");
  return value === "about" ||
    value === "terms" ||
    value === "privacy" ||
    value === "cancellation" ||
    value === "safety" ||
    value === "support"
    ? value
    : null;
}

export function CustomerMore({
  locale,
  onOpenPreferences,
  roleAction,
}: {
  readonly locale: Locale;
  readonly onLocaleChange: (locale: Locale) => void;
  readonly onOpenPreferences?: () => void;
  readonly roleAction?: {
    readonly label: string;
    readonly description: string;
    readonly href: string;
  };
}) {
  const text = content[locale];
  const [showLogin, setShowLogin] = useState(false);
  const [selected, setSelected] = useState<InformationId | null>(requestedInformation);
  const items: Array<{ id: InformationId; title: string; help: string }> = [
    { id: "about", title: text.about, help: text.aboutHelp },
    { id: "terms", title: text.terms, help: text.termsHelp },
    { id: "privacy", title: text.privacy, help: text.privacyHelp },
    { id: "cancellation", title: text.cancellation, help: text.cancellationHelp },
    { id: "safety", title: text.safety, help: text.safetyHelp },
    { id: "support", title: text.support, help: text.supportHelp },
  ];
  return (
    <div className="customer-more">
      <Card className="more-profile-card">
        <BrandLogo compact />
        <div>
          <strong>
            TaungGyi <LinkWordmark />
          </strong>
        </div>
      </Card>
      <section className="more-group">
        <h2>{text.account}</h2>
        {roleAction && (
          <a className="more-menu-row" href={roleAction.href}>
            <span className="more-menu-row__icon" aria-hidden="true">
              ↗
            </span>
            <span>
              <strong>{roleAction.label}</strong>
            </span>
            <b aria-hidden="true">›</b>
          </a>
        )}
        <button className="more-menu-row" type="button" onClick={() => setShowLogin(true)}>
          <span className="more-menu-row__icon" aria-hidden="true">
            ⌁
          </span>
          <span>
            <strong>{text.signIn}</strong>
          </span>
          <b aria-hidden="true">›</b>
        </button>
      </section>
      <section className="more-group" aria-label={text.language}>
        <button className="more-menu-row" type="button" onClick={() => setSelected("about")}>
          <span className="more-menu-row__icon" aria-hidden="true">
            i
          </span>
          <span>
            <strong>{text.about}</strong>
          </span>
          <b aria-hidden="true">›</b>
        </button>
        <button
          className="more-language-row"
          type="button"
          onClick={onOpenPreferences}
          disabled={!onOpenPreferences}
        >
          <GlobeIcon />
          <span>
            <strong>{text.language}</strong>
            <small>{localeLabels[locale]}</small>
          </span>
          <b aria-hidden="true">›</b>
        </button>
      </section>
      <section className="more-group">
        <h2>{text.legal}</h2>
        <div className="more-menu-list">
          {items
            .filter((item) => item.id !== "about")
            .map((item) => (
              <button
                className="more-menu-row"
                type="button"
                key={item.id}
                onClick={() => setSelected(item.id)}
              >
                <MoreMenuIcon name={item.id} />
                <span>
                  <strong>{item.title}</strong>
                </span>
                <b aria-hidden="true">›</b>
              </button>
            ))}
        </div>
      </section>
      <div className="app-version">
        <span>{text.version}</span>
        <strong>0.0.1</strong>
      </div>
      {showLogin && <CustomerAuthDialog locale={locale} onClose={() => setShowLogin(false)} />}
      {selected && (
        <CustomerInformationDialog
          locale={locale}
          id={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}

export function CustomerInformationDialog({
  locale,
  id,
  onClose,
}: {
  readonly locale: Locale;
  readonly id: InformationId;
  readonly onClose: () => void;
}) {
  const text = content[locale];
  const title = text[id];
  const body = text[`${id}Body` as keyof typeof text];
  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", close);
    return () => document.removeEventListener("keydown", close);
  }, [onClose]);
  return (
    <div className="information-dialog-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="information-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="information-dialog-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header>
          <div>
            <p className="eyebrow">
              TaungGyi <LinkWordmark />
            </p>
            <h2 id="information-dialog-title">{title}</h2>
          </div>
          <button
            className="service-dialog__close"
            type="button"
            aria-label={text.close}
            onClick={onClose}
          >
            ×
          </button>
        </header>
        <div className="information-dialog__body">
          <p>{body}</p>
          {id === "about" && (
            <>
              <div className="service-area-note">
                <strong>Taunggyi Town</strong>
                <span>Service area</span>
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
